var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"competition"},[_c('v-banner',{class:`${_vm.competitionClass()}`,attrs:{"single-line":"","color":"primary"}},[_c('span',{staticClass:"open-modal-link",domProps:{"innerHTML":_vm._s(_vm.messageText)}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }